__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/dfc2d00/_next/";